import { Box, Card, Text, useMantineColorScheme } from "@mantine/core";
import { useTranslation } from "react-i18next";

import { Modal } from "../Modal";

import { SettingsList } from "@/components/widgets/UserProfile/components";

import type { FC } from "react";

interface SettingsMobileModalProps {
  opened: boolean;
  onClose: () => void;
}

const SettingsMobileModal: FC<SettingsMobileModalProps> = ({ opened, onClose }) => {
  const { t } = useTranslation();
  const { colorScheme } = useMantineColorScheme({ keepTransitions: true });

  const isDark = colorScheme === "dark";
  const textColor = isDark ? "primaryDark.4" : "secondary.6";

  return (
    <Modal opened={opened} fullScreen onClose={onClose}>
      <Box maw="500px" mb="lg" px="lg">
        <Text size="lg" c={textColor}>
          {t("components.header.settings")}
        </Text>
      </Box>
      <Box maw="500px" m="0 auto">
        {/* User settings */}
        <Card shadow="md">
          <SettingsList />
        </Card>
      </Box>
    </Modal>
  );
};

export default SettingsMobileModal;
